// extracted by mini-css-extract-plugin
module.exports = {"firstFold":"firstFold_firstFold__QGKNa","heading":"firstFold_heading__fZDsp","subParagraph":"firstFold_subParagraph__GaAQV"};